import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const MediumText: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID,
    text = ''
}) => (
    <span className={`${className} ${styles.mediumText}`} data-testid={testId}>
        {children || text}
    </span>
);

export default MediumText;
